import { Box, TableCell } from "@mui/material";
import Icon from "components/icon/icon";
import { BaseTableRow } from "./BaseTableRow";

const getQualityText = (quality: number, t: any) => {
  if (quality <= 1) return t("addressEncoding.tip.geoQuality.ADMIN1");
  if (quality <= 2) return t("addressEncoding.tip.geoQuality.Place");
  if (quality <= 3) return t("addressEncoding.tip.geoQuality.ZIP");
  return t("addressEncoding.tip.geoQuality.Exact");
};

export const CandidatesTableRow = ({
  currency,
  aggregationUnit,
  item,
  selectedId,
  onRowClick,
  handleMove,
  t
}: any) => {
  const handleMoveToSkip = () => handleMove(item.id, "skip");
  const handleMoveDefault = () => handleMove(item.id);

  return (
    <BaseTableRow
      aggregationUnit={aggregationUnit}
      currency={currency}
      item={item}
      selectedId={selectedId}
      onRowClick={onRowClick}
    >
      <TableCell
        sx={{
          fontSize: 13
        }}
      >
        {item.address}
      </TableCell>
      <TableCell
        sx={{
          fontSize: 13
        }}
      >
        {getQualityText(item.quality, t)}
      </TableCell>
      <TableCell>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box
            className="tooltip tooltip-left"
            data-tip={t("addressEncoding.tip.no_match")}
          >
            <Icon
              style={{ color: "orange" }}
              icon="warning"
              onClick={handleMoveToSkip}
            />
          </Box>
          <Box
            className="tooltip tooltip-left"
            data-tip={t("addressEncoding.tip.candidates")}
          >
            <Icon
              style={{ color: "green" }}
              icon="where_to_vote"
              onClick={handleMoveDefault}
            />
          </Box>
        </Box>
      </TableCell>
    </BaseTableRow>
  );
};
